import moment from 'moment-timezone';

import {bffApiSessionTokenTTL} from '~/shared/config';
import {LocalStorageKeys} from '~/shared/consts/localStorageConsts';
import {safeLocalStorage} from '~/shared/utils/safeStorage';

export const getUserSessionToken = () => {
  const sessionTokenObject = safeLocalStorage.getItem(LocalStorageKeys.USER_SESSION_TOKEN);
  const TTL = parseInt(bffApiSessionTokenTTL, 10);
  try {
    const {ts, token} = JSON.parse(sessionTokenObject) || {};

    if (!ts || !token) {
      return;
    }

    const now = moment();
    const timestamp = moment(ts);
    const diff = now.diff(timestamp, 'minutes');

    if (diff < TTL) {
      return token;
    }
    return undefined;
  } catch (err) {
    return undefined;
  }
};

export const setUserSessionToken = token => {
  if (token) {
    safeLocalStorage.setJSON(LocalStorageKeys.USER_SESSION_TOKEN, {ts: Date.now(), token});
  }
};
